export const LANGUAGES = {
    EN:"en",
    JP:"jp"
}